<template>
    <div>
        <div id="sending" v-if="state == 'fetching'">
            <div class="overlay"></div>
            <div class="form-sending"></div>
        </div>
        <modal
            name="reviews"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            width="90%"
            :maxWidth="1100"
            height="auto"
        >
            <div class="modal__content">
                <div class="modal__header container">
                    Keikka-arvostelut - {{ bandName }}
                </div>
                <div class="gigs-list container">
                    <div class="row gigs-list__row" v-for="review in reviews" :key="review.id">
                        <div class="col-md-3 gigs-list__item">
                            <stars :rating="review.points" :round-stars="false"></stars>
                        </div>
                        <div class="col-md-6 gigs-list__item">
                            {{ review.text }}
                        </div>
                        <div class="col-md-3 gigs-list__item">
                            {{ formatDate(review.added) }}
                        </div>
                    </div>
                </div>
                <div class="modal__footer">
                    <span class="btn btn--call-to-action btn--hollow btn--small" @click="closeModal">Sulje</span>
                </div>
            </div>
        </modal>
        <a class="btn btn--info btn--hollow btn--block" @click="openModal">Näytä kaikki arvostelut</a>
    </div>
</template>

<script>
    import moment from 'moment';
    import ApiCall from '../modules/ApiCall';
    import Routes from '../modules/Routes';
    import Stars from './Stars';

    export default {
        components: {
            Stars
        },
        props: {
            bandSlug: {
                type: String
            },
            bandName: {
                type: String
            }
        },
        data() {
            return {
                reviews: [],
                state: 'done'
            };
        },
        methods: {
            fetchReviews() {
                this.showLoading();
                return ApiCall.getCached(this.getUrl(), true).then((response) => {
                    this.reviews = response.reviews;
                    this.hideLoading();
                });
            },
            getUrl() {
                return Routes.generate('_public_api_gig_reviews', { bandSlug: this.bandSlug });
            },
            openModal() {
                this.fetchReviews().then(() => {
                    this.$modal.show('reviews');
                    this.$ga.event('Reviews', 'Show all reviews opened');
                    gtag('event', 'view_all_reviews');
                });
            },
            showLoading() {
                this.state = 'fetching';
            },
            hideLoading() {
                this.state = 'done';
            },
            closeModal() {
                this.$modal.hide('reviews');
                return false;
            },
            formatDate(d) {
                return moment(d).format('D.MM.YYYY');
            }
        },
    };
</script>
